import { apiClient } from './client';
import { appConfig } from '../config/app-config';
import { CancelToken } from 'axios';
import { ProductPermissions } from '../constants/constants';
import { User, IncidentSearchParams, ReferenceKeys } from '../types/types';

export const getCurrentUser = (): Promise<User> =>
  apiClient({
    endpoint: 'user/current',
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'GET',
  });

export const getUserPreferences = (productType: string) =>
  apiClient({
    endpoint: `user/current/preferences/${productType}`,
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'GET',
  });

export const getUserPermissions = (
  productType: string
): Promise<ProductPermissions[]> =>
  apiClient({
    endpoint: `user/current/permissions/${productType}`,
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'GET',
  });

export const setUserPreferences = (
  productType: string,
  payload: Record<string, any>,
  cancelToken?: CancelToken
) =>
  apiClient({
    endpoint: `user/current/preferences/${productType}`,
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'PATCH',
    body: [payload],
    customConfig: { cancelToken },
  });

export const getUserStores = () =>
  apiClient({
    endpoint: 'user/current/stores?q=permissions[:includes]=RACPAD_DAP',
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'GET',
  });

export const getIncidents = (params: IncidentSearchParams): Promise<any> => {
  return apiClient({
    endpoint: 'ticket/search',
    requestType: 'POST',
    body: params,
    apiUrl: appConfig.apiUrls.micro,
    needAccessToken: true,
  });
};

export const getReferences = (
  referenceKey: ReferenceKeys[],
  cacheKey: string
) =>
  apiClient({
    endpoint: 'reference',
    apiUrl: appConfig.apiUrls.micro,
    requestType: 'POST',
    body: { references: referenceKey, cacheKey },
  });

export const GetUserRole = async (Payload: any) =>
  await apiClient({
    endpoint: 'menu-and-stores',
    apiUrl: appConfig.apiUrls.menu,
    requestType: 'POST',
    body: Payload,
  });

export const CreateTicket = async (Payload: any) =>
  await apiClient({
    endpoint: 'ticket/create',
    apiUrl: appConfig.apiUrls.micro,
    requestType: 'POST',
    body: Payload,
  });

export const attachmentsUrl = async (Payload: any) =>
  await apiClient({
    endpoint: 'ticket/attachments',
    apiUrl: appConfig.apiUrls.micro,
    requestType: 'POST',
    body: Payload,
  });

export const fetchDMList = async (Payload: any) =>
  await apiClient({
    endpoint: 'store/lookup',
    apiUrl: appConfig.apiUrls.dashboard,
    requestType: 'POST',
    body: Payload,
  });

export const maganeIncident = async (Payload: any) =>
  await apiClient({
    endpoint: 'ticket/manage',
    apiUrl: appConfig.apiUrls.micro,
    requestType: 'POST',
    body: Payload,
  });

export const getTicketInfo = async (Payload: any) =>
  await apiClient({
    endpoint: 'ticket/info',
    apiUrl: appConfig.apiUrls.micro,
    requestType: 'POST',
    body: Payload,
  });

export const getAgreementData = async (payload: any) =>
  await apiClient({
    endpoint: 'agreement/summary',
    apiUrl: appConfig.apiUrls.opsmgmt,
    requestType: 'POST',
    body: payload,
  });

export const getStoreConfigs = async (payload: any) =>
  await apiClient({
    endpoint: 'store-details',
    apiUrl: appConfig.apiUrls.storemgmt,
    requestType: 'POST',
    body: payload,
  });
